import {createBarbaPage} from '../baseBarbaPage';

export default  createBarbaPage({
    namespace: 'contact',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
        $('form#emailForm').submit(function(){
            $(this).children('button[type=submit]').prop('disabled', true);
        });

        grecaptcha.ready(function () {
            let clientBadge = grecaptcha.render('grecaptchaBadge', {
                'sitekey': '6LePQdcZAAAAAC80u_Ti21zBFEiZByR16Wr55n6V',
                'badge': 'inline',
                'size': 'invisible'
            });

            document.getElementById("emailForm").addEventListener("submit", function (e) {
                e.preventDefault();

                grecaptcha.execute(clientBadge, {action: 'contact'}).then(function (token) {
                    $('input[type=hidden]#recaptchaToken').val(token);
                    $('form#emailForm').submit();
                });
            });
        });
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
    },
    onLeave: function() {
        // A new Transition toward a new page has just started.

    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});


// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!